import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { OpcionDto, QuestionDto } from '../../../dto/justino/question.dto';
import { QuestionService } from '../../../services/question.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ResEncuestaDto } from '../../../dto/justino/res-encuesta.dto';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-encuesta',
  templateUrl: './encuesta.component.html',
  styleUrl: './encuesta.component.scss',
})
export class EncuestaComponent implements OnInit {
  plantilla!: string;
  isLoaded: boolean = false;
  esEncuesta: boolean = true;
  questions: QuestionDto[] = [];
  currentQuestionIndex: number = 0;
  respuestas: { [key: string]: string } = {};

  @Input() userId!: string;
  @Input() processId!: string;

  constructor(
    private router: Router,
    private questionService: QuestionService,
    private alertService: AlertaModalService
  ) {}

  ngOnInit(): void {
    this.loadReview();
  }

  loadReview(): void {
    this.alertService.confirmacion(
      '¿Le fue de utilidad la asistencia de Justino?',
      'Encuesta de satisfacción',
      () => {
        this.plantilla = Constants.ENCUESTA_POSITIVA;
        this.loadQuestions();
      },
      () => {
        this.plantilla = Constants.ENCUESTA_NEGATIVA;
        this.loadQuestions();
      },
      true
    );
  }

  loadQuestions(): void {
    this.questionService.getAllQuestions(this.plantilla).subscribe({
      next: data => {
        const allQuestions = data;
        const set = this.plantilla;
        this.questions = allQuestions.filter(q => q.set === set);
        this.isLoaded = true;
      },
      error: error => {
        this.alertService.error('Error', 'Error al cargar las preguntas');
      },
    });
  }

  get currentQuestion(): QuestionDto {
    return this.questions[this.currentQuestionIndex];
  }

  onSeleccionarRespuesta(opcion: OpcionDto) {
    this.respuestas[this.currentQuestion.id.toString()] = opcion.descripcion + "|" + opcion.abierta;
  }

  onRespuestaAbierta(event: any) {
    const respuestaAbierta = event.target.value;
    this.respuestas[this.currentQuestion.id.toString()] = respuestaAbierta + "|true";
  }

  onSiguiente() {
    if (this.currentQuestion.id in this.respuestas) {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
      }
    } else {
      this.alertService.error('Error', 'Por favor seleccione una respuesta');
    }
  }

  onAnterior() {
    if (this.currentQuestionIndex > 0) {
      this.currentQuestionIndex--;
    }
  }

  reditrect() {
    setTimeout(async () => {
      const url = `/tramites/${this.processId}`;
      await this.router.navigateByUrl(url);
    }, 2000);
  }

  onEnviarEncuesta() {
    if (this.currentQuestion.id in this.respuestas) {
      const respuestasArray = Object.keys(this.respuestas).map(
        key => `${key}: ${this.respuestas[key]}`
      );
      const encuesta: ResEncuestaDto = {
        Id: this.plantilla || 'None',
        UserId: this.userId || 'None',
        Respuestas: respuestasArray,
      };
      console.log('Envia encuesta:', encuesta);
      this.questionService.saveResults(encuesta).subscribe({
        next: data => {
          this.alertService.exito(
            'Mensaje informativo',
            'Encuesta enviada con éxito! Sera redirigido a la página correspondiente.'
          );
          this.esEncuesta = false;
          this.reditrect();
        },
        error: err => {
          console.error('Error creating encuesta:', err);
          this.alertService.error(
            'Error',
            'No se pudo enviar la encuesta. Por favor, inténtelo de nuevo más tarde.'
          );
        },
      });
    } else {
      this.alertService.error('Error', 'Por favor seleccione una respuesta');
    }
  }
}
